module.exports = __webpack_public_path__ + "static/img/bookand.ffd8e222.png";